<template>
    <div class="container-fluid h-100">
      <div class="container mt-5 pt-5">
  
          <div class="row mt-5 pt-3">
            <div class="col-12">
              <h4 class="text-left text-dark font-weight-bold" style="color: #dc3545 !important;">
                  Blog: {{ this.blog.name }}
              </h4>
              </div>
              <div class="col-12">
              <h4 class="text-left text-dark font-weight-bold">
                  Total de comentarios con respuesta: {{ this.totalActiveItems }}
              </h4>
              </div>
               <div class="col-12">
              <h4 class="text-left text-dark font-weight-bold">
                Total de comentarios sin respuesta: {{ this.totalInactiveItems }}
              </h4>
              </div>
              <!-- <div class="col-5 mt-2">
              <input
                  v-model="searchN"
                  type="email"
                  class="form-control"
                  id="exampleFormControlInput1"
                  placeholder="Buscar blog por Nombre"
              />
              </div>            
              <div class="col-1 mt-2">
              <button class="btn btn-danger btn-block" @click="search()">
                  <i class="fa fa-search m-0 p-0" aria-hidden="true"></i>
              </button>
              </div>
              <div class="col-3 mt-2">
              <button class="btn btn-info btn-block" @click="createNewBlog()">
                  Crear nuevo blog
              </button>
              </div> -->
          </div>
  
        <template v-if="loading.history">
          <div class="d-flex justify-content-center">
            <div
              class="spinner-border text-danger"
              style="width: 4em; height: 4rem;"
              role="status"
            ></div>
          </div>
        </template>
  
        <paginate
          v-else
          class="ul-pagination"
          name="items"
          :list="items"
          :per="9"
        >
          <div class="row mt-1">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-striped table-sm">
                  <thead>
                    <tr>
                      <th scope="col" style="text-align: left">Nombre</th>
                      <th scope="col" style="text-align: left">E-Mail</th>
                      <th scope="col" style="text-align: left">Comentario</th>
                      <th scope="col" style="text-align: left">Respuesta</th>
                      <th scope="col" style="text-align: left">Usuario Respuesta</th>
                      <th scope="col" style="text-align: left"></th>
                      <th scope="col" style="text-align: left"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, i) in paginated('items')"
                      :key="'d' + `item-${i}`"
                    >
                      <td style="text-align: left">
                        {{ item.name }}
                      </td>
                      <td style="text-align: left">
                        {{ item.email }}
                      </td>
                      <td style="text-align: left">
                        {{ item.description }}
                      </td>
                      <td style="text-align: left">
                        {{ item.response ? item.response : '--' }}
                      </td>
                      <td style="text-align: left">
                        {{ item.user_id ? `${item.users.name} ${item.users.last_name}` : '--' }}
                      </td>
                      <td style="text-align: left">
                        <label @click="showModal(item)" v-if="!item.response" style="color: #3735DF; cursor:pointer;">
                          <i class="fa fa-duotone fa-eye"></i>
                          Responder comentario
                        </label>
                      </td>
                      <td style="text-align: left">
                        <label @click="deleteComment(item)" style="color: #dc3545; cursor:pointer;">
                          <i class="fa fa-duotone fa-eye"></i>
                          Eliminar
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </paginate>
  
        <div class="row ">
          <div
            class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-12 mt-4 pl-md-5 pl-xl-2"
          >
            <label class="text-p"> Página {{ page }} de {{ totalPage }} </label>
          </div>
          <div
            class="col-12 col-md-9 col-lg-9 col-xl-9 col-sm-12 mt-4 center-paginate"
          >
            <paginate-links
              @change="pageChange"
              for="items"
              :limit="2"
              :show-step-links="true"
              :step-links="{ next: '>', prev: '<' }"
              :classes="{ ul: 'pagination', li: 'page-item', a: 'page-link' }"
            >
            </paginate-links>
          </div>
        </div>
            <div class="col-12 mt-3 mb-3" style="text-align:center">
                <button
                @click="back()"
                type="button"
                class="btn btn-danger btn-sm button-login mr-3"
                >
                Regresar
                </button>
            </div>
      </div>


      <!-- -------------------------------------------------------------------- -->
      <!-- Modal -->
    <div
      class="modal fade"
      id="staticBackdrop"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <p class="subtitle-card text-center" style="margin: 0px;">
              DETALLES DEL COMENTARIO.
            </p>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <formResponseComment
              :comment="this.comment"
              :commentId="this.commentId"
              @cancel="cancelar($event)"
              @buy="buy($event)"
            ></formResponseComment>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>
  
<script>
  import $ from "jquery";
  //import * as XLSX from 'xlsx';
  import formResponseComment from "./formResponseComment";
  import axios from 'axios';
  
  export default {
    components: {
        formResponseComment: formResponseComment
    },
    data() {
      return {
        comment:null,
        commentId:null,
        blogId: null,
        blog:{},
        comments:[],
        totalActiveItems:0,
        totalInactiveItems:0,
        searchN: '',
        loading: {
          history: false,
        },
        items: [],
        paginate: ["items"],
        page: 1,
        totalPage: 1,
      };
    },
    methods: {
      showModal(item){
        this.comment = item.description
        this.commentId = item.id
        $("#staticBackdrop").modal("show");
      },
      cancelar(e) {
        if (e) {
          // console.log("cancelar cart");
          $("#staticBackdrop").modal("hide");
        }
      },
      async buy(resp){
        const user = await sessionStorage.getItem("infoUser");
        this.loading.history = true;
        const data = {
          response: resp,
          userEmail: JSON.parse(user).email
        }
        axios
        .post(`havoblog/responseCommentBlog/${this.commentId}`, data)
        .then(res => {
          if (res.data.cod == 0) {
            $("#staticBackdrop").modal("hide");
            this.loading.history = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message
            });
            this.comment = null
            this.commentId = null
            this.getBlog(this.blogId)
          }
        })
        .catch(error => {
          $("#staticBackdrop").modal("hide");
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
      },
      deleteComment(item){
        console.log(`item ${JSON.stringify(item)}`);
        axios
        .delete(`havoblog/deleteCommentBlog/${item.id}`)
        .then(res => {
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy Bien",
              text: res.data.message
            });
            this.getBlog(this.blogId)
          }
          this.loading.history = false;
        })
        .catch(error => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
      },
      back(){
        this.$router.push({ name: "listHavoblog" });
      },
      search(){
        this.totalActiveItems = 0;
        this.totalInactiveItems = 0;
        this.items = [];
        this.loading.history = true;
        const data = {
          filter: this.searchN.length > 0 ? 1 : 0,
          textFilter: this.searchN
        }
        axios
        .post("havoblog/listBlogs", data)
        .then(res => {
          if (res.data.cod == 0) {
            this.items = res.data.data;
            this.totalPage = Math.ceil(parseInt(this.items.length) / 9);
            this.items.forEach(element => {
              if(element.status_id == 1){
                this.totalActiveItems++;
              } else {
                this.totalInactiveItems++;
              }
            });
          }
          this.loading.history = false;
        })
        .catch(error => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
      },
      editBlog(item){
        this.$router.push({ name: "editHavoblog", params: { blogId: item.id } });
      },
      pageChange(toPage) {
        this.page = toPage;
      },
      showComments(item){
        if(item.havoblog_post_comments.length == 0){
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: 'No hay comentarios para este blog'
          });
        }else{
          //redirigir a comentarios
        }
      },
      getBlog(id){
        let app = this;
        app.totalActiveItems = 0,
        app.totalInactiveItems = 0,
        axios
        .get("havoblog/infoBlog/" + id)
        .then((res) => {
          if(res.data.cod == 0){
            app.blog = res.data.data[0];
            // app.comments = this.blog.havoblog_post_comments
            app.items = this.blog.havoblog_post_comments
            app.items.map((comment)=> {
                if(comment.response){
                    app.totalActiveItems++
                }else{
                    app.totalInactiveItems++
                }
            })
            
            this.totalPage = Math.ceil(parseInt(this.items.length) / 9);
            // Se obtiene la información de los campos
            // app.form.name = app.blog.name;
            // app.form.title = app.blog.title;
            // app.form.subTitle = app.blog.subtitle;
            // app.form.description = app.blog.description;
            // app.form.status = app.blog.status_id;
            // app.form.comment = app.blog.comment;
            // app.listImgs = app.blog.havoblog_post_files;
            // // Se agrega la imagen principal al array de imágenes
            // const imgObj = {
            //   url: app.blog.img,
            //   name: app.blog.img.split('/')[6],
            // };
            // app.listImgs.push(imgObj);
          }
          else{
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: res.data.message
            });
          }
        })
        .catch((error) => {
          console.log('this is the error ', error);
        })
      },
    },
    mounted() {
        this.blogId = this.$route.params.blogId;
        this.getBlog(this.blogId)
        this.pageChange(1);
      //this.search(); //Peticion para listar los blogs
    },
  };
</script>
  
<style>
  .container-fluid,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    padding-right: 0px !important;
    padding-left: 0px !important;
    overflow: hidden;
  }
  
  .div-button {
    margin-top: 50px;
    text-align: left;
  }
  
  .is-danger {
    border: solid 2px !important;
    border-color: #e9434c !important;
  }
  
  .modal-title {
    color: black;
    font-weight: bold;
  }
  
  .modal-question {
    border: solid 3px;
    border-color: #dc3545;
    border-radius: 15px;
  }
  
  label {
    color: black;
    margin-right: 4px;
  }
  
  .img-banner {
    display: block;
    width: 25%;
    text-align: center;
    margin: auto;
  }
  
  td {
    text-align: center;
    vertical-align: -webkit-baseline-middle;
    cursor: all-scroll;
  }
  
  .table-container {
    overflow: auto;
  }
  
  h5 {
    margin-bottom: 10px !important;
  }
  
  .commentary {
    text-align: left;
    color: #1da5df;
    font-size: 13px;
  }
  
  .page-item.active .page-link {
    border-style: none;
    border-radius: 20px;
    background-color: #dc3545;
  }
  
  a.page-link {
    color: black;
    cursor: pointer;
  }
  
  a.page-link:hover {
    color: #dc3545;
  }
  
  .page-link {
    background-color: #f5f5dc00;
    border-radius: 20px;
    border-color: none;
  }
  
  .page-item.disabled .page-link {
    color: #dc3545;
    background-color: #fff0;
    border-color: #dee2e600;
  }
  
  .ul-pagination {
    padding: 0px;
  }
</style>
  